import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Coluna } from '../../models/mat-table-model';
import { TransformService } from '../../services/transform.service';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { SHARED_DIRECTIVES } from '../../utils/shared-directives';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';

@Component({
  selector: 'idba-mat-table-cell',
  standalone: true,
  imports: [CommonModule,
    FlexLayoutModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatSliderModule,
    SHARED_DIRECTIVES
  ],
  templateUrl: './idba-mat-table-cell.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './idba-mat-table-cell.scss'
})
export class IdbaMatTableCellComponent implements OnInit {
  @Input() public column: Coluna;
  @Input() public row: any;

  constructor(public transformService: TransformService) { }

  ngOnInit(): void {

  }

  resolveRouterLink(row: any): string | any[] {
    if (typeof this.column.routerLink === 'function') {
      return this.column.routerLink(row);
    }
    return [this.column.routerLink, row[this.column.routerLinkColumnDef]];
  }

}
